<template>
  <div class="gift-card">
    <im-image v-if="isHasCorner" :src="good.corner" class="gift-badge-img" />
    <div v-if="good.icon" class="gift-icon">
      <img :src="good.icon" alt="" />
    </div>
    <div class="gift-name">{{ good.names && good.names.name }}</div>
    <div class="items-wrapper">
      <div class="items-list">
        <div v-for="(item, index) in goodsItems" :key="index" class="item-row">
          <div class="item-icon">
            <img v-if="item.icon" :src="item.icon" alt="" />
          </div>
          <span class="item-name">{{ item.name }}</span>
          <span class="item-qty">×{{ item.num }}</span>
        </div>
      </div>
    </div>
    <div v-if="hasOriginalPrice || good.is_purchase_limit" class="meta-row">
      <span v-if="hasOriginalPrice" class="original-price">{{ originalPriceInfo.priceTxt }}</span>
      <span v-if="good.is_purchase_limit" class="limit-badge">Limit {{ good.has_purchase_num }}/{{ good.limit_purchase_num }}</span>
    </div>
    <div class="actions">
      <button class="action-btn btn-cart" :class="{ 'is-disabled': isBuyDisabled }" @click="handleCart">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" />
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
        </svg>
      </button>
      <button class="action-btn btn-buy" :class="{ 'is-disabled': isBuyDisabled }" @click="handleBuy">
        {{ priceInfo.labelPrice || priceInfo.priceTxt }}
      </button>
    </div>
  </div>
</template>

<script>
import goodMixins from '../storeWidget/oneGood/goodMixins'
import shopCartMixins from '~/mixins/shopCartMixins'

export default {
  name: 'StoreWidgetV4Item',
  mixins: [goodMixins, shopCartMixins],
  props: {
    model: Object,
    editing: Boolean,
    site: Object
  },
  computed: {
    goodsItems() {
      return [
        ...(this.good.item_contents || []),
        ...(this.good.item_contents2 || []),
        ...(this.good.system_items || [])
      ]
    }
  },
  methods: {
    handleCart() {
      if (this.editing || this.isBuyDisabled) return
      this.handleClick()
    },
    handleBuy() {
      if (this.editing || this.isBuyDisabled) return
      this.$emit('buy', this.good)
    }
  }
}
</script>

<style lang="less">
.gift-card {
  position: relative;
  overflow: hidden;
  min-width: 0;
  box-sizing: border-box;
  padding: 20px 16px 16px;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: var(--card-bg);

  &::before {
    content: '';
    position: absolute;
    top: -60%;
    left: -20%;
    width: 140%;
    height: 100%;
    background: radial-gradient(ellipse at 30% 0%, rgba(245, 200, 66, 0.06) 0%, transparent 70%);
    pointer-events: none;
  }

  // 角标：卡片左上角
  .gift-badge-img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    width: 64px;
    height: 64px;
    pointer-events: none;
  }

  // ICON：卡片顶部横幅
  .gift-icon {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: -20px -16px 14px;
    padding: 28px 0 16px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0) 100%);
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    line-height: 1;

    img {
      width: 64px;
      height: 64px;
      object-fit: contain;
    }
  }

  // 礼包名称：左右居中
  .gift-name {
    position: relative;
    z-index: 1;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    color: var(--text-color);
    margin-bottom: 14px;
    letter-spacing: -0.2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  // 道具列表：固定高度可上下滑动
  .items-wrapper {
    height: 330px;
    overflow-y: auto;
    margin-bottom: 14px;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .items-list {
    display: flex;
    flex-direction: column;
  }
  .item-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
  }
  .item-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.04);
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .item-name {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-color);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item-qty {
    flex-shrink: 0;
    width: 76px;
    font-size: 13px;
    font-weight: 600;
    color: var(--text-color);
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  // 划线价 + 限购：同一行，左对齐 + 右对齐
  .meta-row {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
    min-height: 20px;
  }
  .original-price {
    font-size: 14px;
    color: var(--text-color);
    opacity: 0.55;
    text-decoration: line-through;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .limit-badge {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 4px;
    background: rgba(245, 200, 66, 0.12);
    color: var(--text-color);
    font-size: 11px;
    font-weight: 600;
    line-height: 1.5;
    white-space: nowrap;
  }

  // 购物车 + 购买按钮：底部
  .actions {
    position: relative;
    z-index: 1;
    display: flex;
    gap: 10px;
  }
  .action-btn {
    height: 48px;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.15s, box-shadow 0.2s;
    background: var(--button-bg);
    color: var(--button-color);

    &:active {
      transform: scale(0.94);
    }

    &.is-disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  .btn-cart {
    width: 52px;
    flex-shrink: 0;

    svg {
      width: 22px;
      height: 22px;
    }
  }
  .btn-buy {
    flex: 1;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: 0.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 12px;
  }
}
</style>
